<template>
  <div class="busca">
    <v-autocomplete
      placeholder="Buscar"
      prepend-icon="mdi mdi-magnify"
      v-model="select"
      :items="totalList"
      item-text="label"
      item-value="label"
    >
      <template v-slot:item="data">
        <router-link :to="data.item.route">
          <div class="container-select">
            <div class="container-title-search">
              <div class="icone-paper">
                <span class="mdi mdi-file-outline"></span>
              </div>
              <div>
                <div class="category">{{ data.item.label }}</div>
                <div class="title">{{ data.item.label }}</div>
                <div class="route">{{ data.item.route }}</div>
              </div>
            </div>
            <!-- <div class="description">{{ data.item.info }}</div> -->
          </div>
        </router-link>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    groups: {
      type: Array,
    },
  },
  data() {
    return {
      select: '',
    }
  },
  watch: {
    select() {
      const seleted = this.totalList.find((item) => item.label === this.select)
      this.$emit('searchSelect', seleted)
    },
  },
  computed: {
    totalList() {
      const children = (item) => {
        let list = [item]
        if (item.children && item.children.length > 0) {
          for (const child of item.children) {
            list = list.concat(children(child))
          }
        }
        return list
      }

      let list = []
      for (const group of this.groups) {
        list = list.concat(children(group))
      }

      return list
    },
  },
  methods: {},
}
</script>

<style scoped lang="scss" src="./styles.scss" />
